import DataGrid, { Column } from 'devextreme-react/data-grid';
import { bllSharedCellStyling } from '../../common/constants/tables/cells/styles/bllSharedCellStyling';
import { BorrowerLendingLimitTableType } from '../../common/constants/tables/BorrowerLendingLimitTableType';
import { currencyCellItemRender } from '../../common/constants/tables/cells/renders/currencyCellItemRender';
import { countCellRender } from '../../common/constants/tables/cells/renders/countCellRender';
import { summaryItemTypeCellRender } from '../../common/constants/tables/cells/renders/summaryItemCellRender';
import { RentalRows } from '../../common/constants/tables/rows/RentalRows';
import { RentalColumns } from '../../common/constants/tables/columns/RentalColumns';
import { ILoanHistorySummaryTableRow } from '../../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { IRentalTableRow } from '../../common/constants/tables/interfaces/IRentalTableRow';

interface RentalTableProps {
    rentalData: IRentalTableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const RentalTable: React.FC<RentalTableProps> = ({ onLoanSummaryClick, rentalData }) => {
    const rowSpecificCellStyling = (e) => {
        switch (e.row?.data?.summaryItemType) {
            case RentalRows.DSCR:
                e.cellElement.style.borderTop = '2px solid gray';
                break;
            default:
                break;
        }
    };

    const prepareCells = (e) => {
        //Run shared styling
        bllSharedCellStyling(e);

        //Run row specific styling
        rowSpecificCellStyling(e);
    };

    const showEyeForRental = (e) => {
        return e.data.summaryItemType === RentalRows.DSCR;
    };

    return (
        <>
            <DataGrid
                dataSource={rentalData}
                keyExpr='summaryItemType'
                showBorders={false}
                showRowLines={false}
                rowAlternationEnabled={true}
                remoteOperations={false}
                allowColumnReordering={true}
                allowColumnResizing={true}
                noDataText='No Rental Information Available'
                onCellPrepared={(e) => {
                    prepareCells(e);
                }}
                style={{ padding: '10px' }}
            >
                <Column
                    dataField={RentalColumns.SummaryItemType}
                    caption=''
                    alignment={'left'}
                    width={160}
                    cellRender={(e) =>
                        summaryItemTypeCellRender(e, BorrowerLendingLimitTableType.Rental, RentalColumns.SummaryItemType)
                    }
                />
                <Column
                    dataField={RentalColumns.OutstandingAmount}
                    caption='Outstanding'
                    width={140}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.Rental)}
                />
                <Column
                    dataField={RentalColumns.OutstandingNumber}
                    caption=''
                    width={70}
                    alignment={'left'}
                    cellRender={(e) =>
                        countCellRender(
                            e, // only the row data, no circular refs
                            () => onLoanSummaryClick(e.data.outstandingLoans),
                            showEyeForRental
                        )
                    }
                />
                <Column
                    dataField={RentalColumns.BfiRepaysAmount}
                    caption='BFI Repays'
                    width={120}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.Rental)}
                />
                <Column
                    dataField={RentalColumns.BfiRepaysNumber}
                    caption=''
                    alignment={'left'}
                    cellRender={(e) =>
                        countCellRender(
                            e, // only the row data, no circular refs
                            () => onLoanSummaryClick(e.data.bfiRepaysLoans),
                            showEyeForRental
                        )
                    }
                />
            </DataGrid>
        </>
    );
};
